import { en } from '../translations/en';
export const defaultLanguage = 'en';
export type SupportedLanguage = 'en';

export const messages = {
  en,
};
